<span
  wfsTooltip
  [tooltipText]="buttonTooltip()"
  [tooltipShowDelay]="tooltipDelay()"
  [tooltipClass]="'mat-tooltip-button'">
  <button
    #btnRef
    class="btn"
    (click)="onClick(btnRef)"
    [disabled]="disabled()"
    [attr.aria-label]="ariaLabel() ?? label()"
    [class]="buttonClasses()">
    @if (icon().length > 0) {
      <i [class]="icon()"></i>
    }

    @if (label().length > 0) {
      {{ label() }}
    }

    @if (buttonStyle() === 'close') {
      &times;
    }
  </button>
</span>
